import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import FormFieldWithLabel, { renderInfoIcon } from '../../common/FormFieldWithLabel';
import CustomSelect from '../../../common/formElements/CustomSelect';
import {
  getPathCollection,
  getPathFieldOptions,
  pathOptions,
} from '../../../common/utils/page_utils';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { CustomModal } from '../../../common/ui/CustomModal';

export const DynamicLinksModal = ({
  isOpen,
  toggle,
  pages,
  collections,
  parentCollection,
  insertTextToParamInput,
  copyToClipboard,
}) => {
  const [hrefUrl, setHrefUrl] = useState('');
  const [page, setPage] = useState('');
  const [path, setPath] = useState('');
  const [pathField, setPathField] = useState('');
  const [pathCollection, setPathCollection] = useState(null);

  const pageOptions = pages
    ? pages.map((page) => ({
        value: '/' + page.slug,
        label: page.name,
      }))
    : [];

  const clipboardStyle = {
    cursor: 'pointer',
    padding: '4px',
    verticalAlign: 'middle',
    margin: 0,
  };

  const addBtn = {
    cursor: 'pointer',
    fontSize: '0.75rem',
    padding: '4px',
    verticalAlign: 'middle',
    margin: 0,
  };

  const handleToggle = () => {
    setHrefUrl('');
    setPage('');
    setPath('');
    setPathField('');
    setPathCollection(null);
    toggle();
  };

  const pathFieldOptions = () => {
    let pathOptions = [];
    if (page && path && pathCollection) {
      const { fields } = pathCollection;
      pathOptions = getPathFieldOptions(path, fields, collections);
    }
    return pathOptions;
  };

  const handlePageChange = (name, value) => {
    setPage(value);
    const oldPage = hrefUrl.split('/')[1];
    const newHrefUrl = oldPage ? hrefUrl.replace('/' + oldPage, value) : value;
    setHrefUrl(newHrefUrl);
    if (path) handlePathChange('', path, value, newHrefUrl);
  };
  const handlePathChange = (name, value, pageSlug = '', pageHrefUrl = '') => {
    pageSlug = pageSlug ? pageSlug : page;
    pageHrefUrl = pageHrefUrl ? pageHrefUrl : hrefUrl;
    const pathCollection = getPathCollection(value, pageSlug, parentCollection, pages, collections);
    setPath(value);
    setPathCollection(pathCollection);
    if (pathCollection) {
      const pathCollectionName = pathCollection.collectionName;
      const oldPath = pageHrefUrl.split('/')[2];
      const newHrefUrl = oldPath
        ? pageHrefUrl.replace(oldPath, pathCollectionName)
        : pageHrefUrl + '/' + pathCollectionName;
      setHrefUrl(newHrefUrl);
    }
  };
  const handlePathFieldChange = (name, value) => {
    setPathField(value);
    const oldPathField = hrefUrl.split('/')[3];
    const newHrefUrl = oldPathField ? hrefUrl.replace(oldPathField, value) : hrefUrl + '/' + value;
    setHrefUrl(newHrefUrl);
  };

  return (
    <CustomModal
      isOpen={isOpen}
      toggle={handleToggle}
      size="lg"
      header={
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ width: '45rem' }}
        >
          <strong>Add Dynamic Links</strong>
        </div>
      }
      body={
        <>
          {hrefUrl && (
            <blockquote className="blockquote border-brand-green d-flex align-items-center">
              {renderInfoIcon('Link', 'Dynamic Link description')}
              <strong>Link:</strong>&nbsp;
              <CopyToClipboard
                text={hrefUrl}
                onCopy={() => {
                  copyToClipboard('Copied to clipboard');
                  handleToggle();
                }}
                title={'Copy to clipboard'}
                style={clipboardStyle}
              >
                <span>
                  {hrefUrl} <i className="webconnect webconnect-files" />
                </span>
              </CopyToClipboard>
            </blockquote>
          )}
          <Formik enableReinitialize={true} initialValues={{}}>
            {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
              <Form>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <FormFieldWithLabel cta={false} label="Page" icon="select">
                        <CustomSelect
                          name={'page'}
                          isMulti={false}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          options={pageOptions}
                          value={page}
                          placeholder={'Page'}
                          onChangeValue={handlePageChange}
                        />
                      </FormFieldWithLabel>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <FormFieldWithLabel cta={false} label="Path" icon="select">
                        <CustomSelect
                          name={'path'}
                          isMulti={false}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          options={page ? pathOptions : []}
                          value={path}
                          placeholder={'Path'}
                          onChangeValue={handlePathChange}
                        />
                      </FormFieldWithLabel>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <FormFieldWithLabel cta={false} label="Path Field" icon="select">
                        <CustomSelect
                          name={'pathField'}
                          isMulti={false}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          options={pathFieldOptions()}
                          value={pathField}
                          placeholder={'Path Field'}
                          onChangeValue={handlePathFieldChange}
                        />
                      </FormFieldWithLabel>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-lg-12 mt-4 text-right">
                  <button
                    type="button"
                    className="btn btn-md btn-theme-submit"
                    title="Insert Links"
                    onClick={() => {
                      insertTextToParamInput(hrefUrl, 'Link Inserted');
                      handleToggle();
                    }}
                  >
                    <i className={`wb ${drapcodeIcon('add')}`}></i>&nbsp;Insert
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </>
      }
    />
  );
};
